import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Accordion } from "react-bootstrap";
import { useNavigate } from "react-router";
import "./../faq/faqQuestions.css";
import { fetchFaqData } from "../../redux/Actions/policyActions";
import { LOCAL_API_BASE_URL } from "../../config";

function FAQ() {
  const navigate = useNavigate();

  const dispatch = useDispatch<any>();

  const faqData: any = useSelector<any>((state) => state?.faq);
  const settingsData: any = useSelector<any>((state) => state?.settings);

  var metaTitle = "";
  var metaDescription = "";

  const shopURL = window.location.href;
  const isXcelShop =
    shopURL?.includes("xceldrycleaner") ||
    (window.location.hostname === "localhost" &&
      LOCAL_API_BASE_URL?.includes("xceldrycleaner"));
  const isLaundryUp =
    shopURL?.includes("laundryup") ||
    (window.location.hostname === "localhost" &&
      LOCAL_API_BASE_URL?.includes("laundryup"));

  useEffect(() => {
    if (isXcelShop) {
      metaTitle = "Dry Cleaning FAQs | Xcel Dry Cleaners London";
      metaDescription = "Answers to your most common dry cleaning questions — turnaround times, fabric care, collection & delivery, and more.";
    } else if (isLaundryUp) {
      metaTitle = "FAQs | LaundryUp Laundry & Dry Cleaning Watford";
      metaDescription = "Answers on booking, pickup & delivery, turnaround times and payment for LaundryUp's laundry and dry cleaning service in Watford.";
    } else {
      metaTitle = settingsData?.WebsiteSettings?.site_title_en + " FAQ | Frequently Asked Questions about Laundry and Dry Cleaning Services";
      metaDescription = "Explore the " + settingsData?.WebsiteSettings?.site_title_en + " FAQ to find answers to common questions about our laundry and dry cleaning services in London. Learn more about our services and book online today!";
    }
    document.title = metaTitle;
    document.getElementById("title")?.setAttribute("content", metaTitle);
    document.getElementById("description")?.setAttribute("content", metaDescription);

    dispatch(fetchFaqData());
  }, []);

  return (
    <div>
      <div className="breadcrumpset">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumpview">
                <h2>FAQ'S</h2>
                <ul>
                  <li>
                    <a href="/">
                      <i className="fa fa-home" aria-hidden="true"></i>{" "}
                    </a>
                  </li>
                  <li>
                    <span> Frequently asked questions</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="section-faq">
        <div className="container">
          <div className="row ">
            <div className="col-md-12 d-none">
              <ol className="breadcrumb">
                <li>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/");
                    }}
                  >
                    Home
                  </a>
                </li>
                <li className="active">FAQs</li>
              </ol>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="faq-content d-none">
                <h2>FAQ'S</h2>
                <p>Quickly find out it we've already addressed your qurey</p>
              </div>
              {faqData?.map((item: any) => {
                return (
                  <Accordion
                    alwaysOpen
                    className="faq-grp"
                  >
                    <Accordion.Item eventKey={JSON.stringify(item?.id)}>
                      <Accordion.Header>{item?.question}</Accordion.Header>
                      <Accordion.Body>{item?.answer}</Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
